import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { Badge } from '../../components/ui/Badge.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { MetricCard } from '../../components/ui/Card.jsx';
import { Table } from '../../components/ui/Table.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { inventoryApi } from '../../services/inventoryApi.js';
import { formatNumber } from '../../utils/formatters.js';

import { InspectionLotModal } from './InspectionLotModal.jsx';
import { InspectionLotDetailModal } from './InspectionLotDetailModal.jsx';

const STATUS_VARIANT = { OPEN: 'warning', ACCEPTED: 'success', REJECTED: 'danger' };

export function QualityPage() {
  const { t } = useTranslation();
  const [createOpen, setCreateOpen] = useState(false);
  const [detailId, setDetailId] = useState(null);

  const list = useQuery({ queryKey: ['inventory', 'inspection-lots'], queryFn: () => inventoryApi.listInspectionLots().then((r) => r.items) });
  const rows = list.data || [];
  const count = (s) => rows.filter((r) => r.status === s).length;

  const columns = [
    { key: 'lotNumber', label: t('qm.col.number'), render: (r) => <span className="mono">{r.lotNumber}</span> },
    { key: 'product', label: t('qm.col.product'), render: (r) => <span><strong>{r.productSku}</strong> <span className="muted text-sm">{r.productName}</span></span> },
    { key: 'quantity', label: t('qm.col.quantity'), align: 'right', render: (r) => <span className="mono num">{formatNumber(r.quantity)}</span> },
    { key: 'source', label: t('qm.col.source'), render: (r) => t(`qm.source.${r.source}`) },
    { key: 'status', label: t('col.status'), render: (r) => <Badge variant={STATUS_VARIANT[r.status]}>{t(`qm.status.${r.status}`)}</Badge> },
    { key: 'actions', label: '', align: 'right', render: (r) => <Button size="sm" variant="ghost" onClick={() => setDetailId(r.id)}>{t('qm.action.view')}</Button> },
  ];

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1>{t('qm.title')}</h1>
          <p className="muted">{t('qm.subtitle')}</p>
        </div>
        <div className="page-actions">
          <Button variant="primary" onClick={() => setCreateOpen(true)}>{t('qm.action.new')}</Button>
        </div>
      </header>

      <div className="card-grid">
        <MetricCard label={t('qm.metric.open')} value={String(count('OPEN'))} trendVariant={count('OPEN') > 0 ? 'warning' : 'success'} />
        <MetricCard label={t('qm.metric.accepted')} value={String(count('ACCEPTED'))} trendVariant="success" />
        <MetricCard label={t('qm.metric.rejected')} value={String(count('REJECTED'))} trendVariant="danger" />
      </div>

      <Table columns={columns} rows={rows} isLoading={list.isLoading} emptyMessage={t('qm.empty')} />

      <InspectionLotModal open={createOpen} onClose={() => setCreateOpen(false)} />
      <InspectionLotDetailModal lotId={detailId} onClose={() => setDetailId(null)} />
    </section>
  );
}
